import { combineReducers } from 'redux';

import {
  authInitRequest,
  authInitSuccess,
  authInitFail,
  logInFail,
  logInRequest,
  logInSuccess,
  logOut,
  refreshFail,
  refreshRequest,
  refreshSuccess,
} from '../actions';
import { AuthAction } from '../types';
import tokens from './tokens';


const loading = (state = false, action: AuthAction) => {
  switch (action.type) {
    case logInRequest.type:
    case refreshRequest.type:
    case authInitRequest.type:
      return true;

    case logInSuccess.type:
    case logInFail.type:
    case authInitSuccess.type:
    case authInitFail.type:
    case logOut.type:
    case refreshFail.type:
    case refreshSuccess.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  tokens,
  loading,
});
